import Reveal from "@/components/feature/Reveal";
import SectionTitle from "@/components/feature/SectionTitle";
import { services } from "@/mocks/services";
import MascotAccent from "@/components/feature/MascotAccent";

export default function Services() {
  return (
    <section id="service" className="relative overflow-hidden bg-background-50 py-16 md:py-24">
      <MascotAccent variant="cert" className="right-6 top-8 hidden h-20 w-20 -rotate-3 xl:block" />
      <div className="site-container">
        <Reveal>
          <SectionTitle
            upper="SERVICE"
            under="不用品回収を入口に、暮らしの片付けに関するご相談を幅広く承ります。"
          >
            対応できるサービス
          </SectionTitle>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-3 md:mt-12 md:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={i * 60}>
              <article className="grid h-full grid-cols-[auto_1fr] items-start gap-x-2.5 gap-y-2.5 rounded-lg border border-background-200 bg-background-100/70 p-3.5 transition-colors hover:border-primary-300 md:gap-x-3 md:gap-y-3 md:p-5">
                <span className="col-start-1 row-start-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50 md:h-12 md:w-12">
                  <i className={`${s.icon} text-xl md:text-2xl`} />
                </span>
                <div className="col-start-2 row-start-1 min-w-0">
                  <h3 className="text-balance font-heading text-base font-black leading-tight text-foreground-950 md:text-xl">
                    {s.title}
                  </h3>
                  <p className="text-xs font-bold leading-tight text-primary-700 md:text-sm">{s.subtitle}</p>
                </div>
                <p className="col-start-2 row-start-2 min-w-0 text-sm leading-relaxed text-foreground-600 md:col-span-2 md:text-base">{s.text}</p>
                <ul className="col-span-2 row-start-3 hidden flex-wrap gap-1.5 md:flex">
                  {s.points.map((p) => (
                    <li
                      key={p}
                      className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-bold text-secondary-900"
                    >
                      {p}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}